import { writable } from 'svelte/store';
import { persist, createSessionStorage, setSerialization } from '@macfja/svelte-persistent-store';
import { customSerialization } from './serialization.js';

setSerialization(...customSerialization);

const translationActive = persist(writable(false), createSessionStorage(), 'translationActive');
const translationLanguage = persist(writable('es'), createSessionStorage(), 'translationLanguage');
const translationRollover = persist(writable(false), createSessionStorage(), 'translationRollover');

export {
    translationActive,
    translationLanguage,
    translationRollover,
};